import type { BackendTypes } from '@tf/api';

import { useTenantCapabilities } from '@/core/api/users';

import { capabilities } from './capabilities';

export const useCapabilities = () => {
	const { data: tenantCapabilities } = useTenantCapabilities();

	const allCapabilities = Object.entries(capabilities).map(([value, label]) => {
		return {
			value: value as BackendTypes.RoleCapabilityValue,
			label,
		};
	});

	return allCapabilities.filter((c) => tenantCapabilities?.includes(c.value));
};
